/* eslint-disable no-warning-comments */
/* eslint arrow-body-style: ["error", "as-needed"] */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import './css/HelpPlanningCta.styl';
import HelpPlanningQuestion from '../HelpPlanningQuestion';
import LeadForm from '../../../../../shared/LeadForm';
import {
  buildSalesforcePayload,
  sendToWebcollect,
} from '../../../../../../appModules/utilities/salesforceApi';

const initialValues = {
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: '',
};

const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export class HelpPlanningForm extends Component {
  static propTypes = {
    affiliate: React.PropTypes.object,
    funeralHome: React.PropTypes.object,
    planning: React.PropTypes.bool,
  };

  state = {
    planning: this.props.planning,
  };

  onAnswer = () => {
    this.setState({
      planning: true,
    });
  };

  handleFormSubmit = (formValues, formik) => {
    const {funeralHome, affiliate} = this.props;

    formik.setStatus({
      loading: true,
      error: false,
    });

    const body = buildSalesforcePayload({
      form: 'helpPlanning',
      formValues,
      funeralHome,
      affiliate,
    });

    sendToWebcollect({body})
      .then(json => {
        const {success, error = undefined} = json; // eslint-disable-line no-undefined

        formik.setSubmitting(false);
        formik.setStatus({
          loading: false,
          success,
          error,
        });
      })
      .catch(() => {
        formik.setSubmitting(false);
        formik.setStatus({
          loading: false,
          error: true,
          success: false,
        });
      });
  };

  render() {
    const {planning} = this.state;

    const fields = [
      {
        name: 'firstName',
        title: 'First Name',
        required: true,
      },
      {
        name: 'lastName',
        title: 'Last Name',
        required: true,
      },
      {
        name: 'email',
        type: 'email',
        title: 'Email',
        required: true,
      },
      {
        name: 'phoneNumber',
        type: 'tel',
        title: 'Phone Number',
        required: true,
      },
    ];

    if (planning) {
      return (
        <div className="help-planning-form">
          <header className="help-planning-form__header">
            Get a Free, Custom Funeral Plan
          </header>
          <p className="help-planning-form__info">
            A specialist from the funeral home will contact you to discuss your
            needs.
          </p>
          <LeadForm
            initialValues={initialValues}
            onSubmit={this.handleFormSubmit}
            submitText="Contact Me"
            fields={fields}
            renderSuccess={() => (
              <p className="Success">
                Someone will be in contact with you shortly.
              </p>
            )}
          />
        </div>
      );
    }
    return <HelpPlanningQuestion onAnswer={this.onAnswer} />;
  }
}

const mapStateToProps = state => ({
  affiliate: state.affiliateStore,
  funeralHome: state.funeralHomeStore,
  planning: state.planningStore.isPlanning,
});

export default connect(mapStateToProps)(HelpPlanningForm);



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Shared/HelpPlanningCta/index.js